'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { FloatingGiftBoxControllerMount } from '@/app/donation/_components/FloatingGiftBoxControllerMount';
import { PageNavigation } from '@/components/client';
import { useAuthStore } from '@/stores/AuthStore';
import { DesktopDonationCountList } from './_components/DesktopDonationCountList';
import { LoginRequiredSection } from './_components/LoginRequiredSection';
import { NavigationArea } from './_components/NavigationArea';
import { ProfileSummarySection } from './_components/ProfileSummarySection';
const MyPage = () => {
  const $ = _c(11);
  const myInfo = useAuthStore(_temp);
  const isMyInfoLoading = myInfo === undefined;
  const isGuest = !isMyInfoLoading && !myInfo;
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <FloatingGiftBoxControllerMount />;
    t1 = <PageNavigation donationHomeButton={true} isNotUsedHomeButton={true} />;
    t2 = cn("flex flex-col", "mobile-tablet:px-20 mobile-tablet:pt-28 ");
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== isGuest) {
    t3 = isGuest ? <LoginRequiredSection className="mb-16" /> : <ProfileSummarySection className="mobile-tablet:mb-16" />;
    $[3] = isGuest;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <NavigationArea className="hidden mobile-tablet:block" />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== isGuest) {
    t5 = <DesktopDonationCountList isGuest={isGuest} />;
    $[6] = isGuest;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t5) {
    t6 = <>{t0}{t1}<article className={t2}>{t3}{t4}{t5}</article></>;
    $[8] = t3;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};
export default MyPage;
function _temp(state) {
  return state.myInfo;
}